import { booleanAttribute, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { IconName } from '@fortawesome/fontawesome-common-types'

@Component({
	selector: 'sbpro-dashboard-head',
	templateUrl: './dashboard-head.component.html',
	styleUrls: ['dashboard-head.component.scss'],
	standalone: false
})
export class DashboardHeadComponent implements OnInit {
	@Input() icon!: string
	@Input() title!: string
	@Input() awesome = false
	@Input() description!: string
	@Input() breadcrumbs = false
	@Input() simplified = false
	@Input() light = true
	@Input({ transform: booleanAttribute }) dateSelect!: false
	@Input() showSearch!: false

	@Input() loading = false
	@Input() dateRange: boolean = true
	@Input() dateSelectValue!: DateSelectItem
	@Input() dateSelectItems: Array<DateSelectItem> = []

	@Output() selected: EventEmitter<DateSelectItem> = new EventEmitter()

	constructor() {}

	ngOnInit() {}

	get iconProp(): IconProp | undefined {
		if (this.icon) return ['fas', this.icon as IconName]
	}

	dateSelected(item: DateSelectItem) {
		this.selected.next(item)
		this.dateSelectValue = item
	}
}

export interface DateSelectItem {
	label: string
	value: any
}
